   /**
    * Pauses execution of an async function for the given number of milliseconds.
    * @param {number} duration in milliseconds (default: 1000)
    */
   export default async (duration = 1000) => new Promise((resolve) => setTimeout(resolve, duration));
